(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mega-menu-with-icons"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const triggerBtn = document.querySelector('.new-mega-menu__button-btn');
  const shadow = document.getElementById('newMegaDrawerShadow');
  const drawer = document.getElementById('newMegaDrawer');
  const content = document.getElementById('newMegaDrawerContent');
  const header = document.getElementById('newMegaDrawerHeader');

  if (triggerBtn) triggerBtn.addEventListener('click', showNewMegaDrawer);
  if (shadow) shadow.addEventListener('click', hideNewMegaDrawer);

  // Drawer nav state
  let currentLevel = 'primary';
  let previousTitleStack = [];

  function showMenu(level, parentTitle = null, isBack = false) {
    const currentActive = document.querySelector('.new-mega-drawer-list.active-item');
    if (currentActive) {
      currentActive.classList.remove('active-item');
      currentActive.style.transform = isBack ? 'translateX(100%)' : 'translateX(-100%)';
    }

    const next = level === 'primary'
      ? document.querySelector('.new-mega-drawer-list--primary')
      : document.querySelector(`.new-mega-drawer-list--${level}[data-parent="${parentTitle}"]`);

    if (!next) return;

    next.style.transform = 'translateX(100%)';
    requestAnimationFrame(() => {
      next.classList.add('active-item');
      next.style.transform = 'translateX(0)';
    });

    if (level === 'primary') previousTitleStack = [];
    else if (!isBack) previousTitleStack.push(parentTitle);

    currentLevel = level;
  }

  showMenu('primary');

  // Forward nav
  document.querySelectorAll('.new-mega-drawer-item-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const hasChildren = link.parentNode.getAttribute('data-has-children') === 'true';
      if (hasChildren) {
        e.preventDefault();
        const parentTitle = link.getAttribute('data-title');
        const nextLevel = currentLevel === 'primary' ? 'child' : 'grandchild';
        showMenu(nextLevel, parentTitle, false);
      }
    });
  });

  // Back buttons
  document.querySelectorAll('.new-mega-drawer-back .back-to-primary').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showMenu('primary', null, true);
    });
  });

  document.querySelectorAll('.new-mega-drawer-back .back-to-child').forEach(function (btn) {
    btn.addEventListener('click', function () {
      previousTitleStack.pop();
      const parentTitle = previousTitleStack[previousTitleStack.length - 1];
      showMenu('child', parentTitle, true);
    });
  });

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideNewMegaDrawer();
  });

  // Resize behavior
  window.addEventListener('resize', adjustNewMegaDrawerSize);
});

let isNewMegaDrawerOpen = false;

function showNewMegaDrawer() {
  const drawer = document.getElementById('newMegaDrawer');
  const shadow = document.getElementById('newMegaDrawerShadow');
  const content = document.getElementById('newMegaDrawerContent');
  const header = document.getElementById('newMegaDrawerHeader');

  if (!drawer || !shadow || !content) return;

  // Mark open FIRST so adjustNewMegaDrawerSize runs properly
  isNewMegaDrawerOpen = true;
  adjustNewMegaDrawerSize();

  // Animate in
  drawer.style.transition = 'width 0.3s ease';
  drawer.style.width = '424px';

  shadow.style.visibility = 'visible';
  shadow.style.opacity = '1';
  shadow.style.pointerEvents = 'auto';

  setTimeout(() => {
    content.style.opacity = '1';
    if (header) header.style.position = 'fixed';
  }, 300);
}

function hideNewMegaDrawer() {
  const drawer = document.getElementById('newMegaDrawer');
  const shadow = document.getElementById('newMegaDrawerShadow');
  const content = document.getElementById('newMegaDrawerContent');
  const header = document.getElementById('newMegaDrawerHeader');

  if (!drawer || !shadow || !content) return;

  content.style.opacity = '0';
  shadow.style.pointerEvents = 'none';
  shadow.style.opacity = '0';
  shadow.style.visibility = 'hidden';

  drawer.style.transition = 'width 0.3s ease';
  drawer.style.width = '0';

  setTimeout(() => {
    if (header) header.style.position = 'relative';
    isNewMegaDrawerOpen = false;
  }, 300);
}

function adjustNewMegaDrawerSize() {
  const drawer = document.getElementById('newMegaDrawer');
  if (!drawer || !isNewMegaDrawerOpen) return;

  if (window.innerWidth <= 749) {
    drawer.style.height = 'calc(100% - 12px)';
    drawer.style.width = '424px';
  } else {
    drawer.style.width = '424px';
    drawer.style.height = 'calc(100% - 12px)';
  }
}

window.showNewMegaDrawer = showNewMegaDrawer;
window.hideNewMegaDrawer = hideNewMegaDrawer;


  } catch(e) { console.error(e); }
})();
})();
